import React, { ReactElement } from 'react';
import { Col } from 'react-bootstrap';
import classNames from 'classnames';

type KpiTileProps = {
  title: string;
  subtitle: string | ReactElement;
  icon: ReactElement
  className?: string
};
function KpiTile( {
  title, subtitle, icon, className,
}: KpiTileProps ) {
  return (
    <Col className={classNames( className, 'text-center pt-4' )} lg={3} xs={6}>
      {icon}
      <p className="text--bold mb-1 mt-2 paragraph">{title}</p>
      <p className="text--bold m-0 paragraph">{subtitle}</p>
    </Col>
  );
}

export default KpiTile;
